__webpack_require__.p = "https://assets.korukids.co.uk/packs/";